export default {
    widgetActivePage: 'widgetActivePage',
    widgetLastActiveTime: 'widgetLastActiveTime',
    activeChannelId: 'activeChannelId',
    widgetSessionActive: 'widgetSessionActive',
    disabledConversation: 'disabledConversations',
    notificationRead: 'notificationRead',
    widgetPopSoundNoti: 'widgetPopSoundNoti',
    titleAlert: 'titleAlert',
  };
  